import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmButton from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  () => ({
    dialogContent: {
      padding: "20px",
      textAlign: "center"
    }
  }),
  { name: "CancelBatchDialog" }
);

interface CancelBatchDialogProps {
  confirmButtonLabel: string;
  cancelButtonLabel: string;
  loading: boolean;
  open: boolean;
  onClose: () => void;
  listElements?: string[];
  onConfirm?: () => void;
}

function CancelBatchDialog(props: CancelBatchDialogProps) {
  const {
    cancelButtonLabel,
    confirmButtonLabel,
    loading,
    listElements,
    open,
    onClose,
    onConfirm
  } = props;
  const classes = useStyles(props);

  return (
    <Dialog fullWidth onClose={!loading && onClose} open={open} maxWidth="xs">
      <DialogTitle></DialogTitle>
      <DialogContentText className={classes.dialogContent}>
        <FormattedMessage
          defaultMessage={`Are you sure you wanted to cancel {total} ?`}
          values={{
            total: listElements.length === 1 ? "this batch" : "these batches"
          }}
        />
      </DialogContentText>
      <DialogActions>
        <Button disabled={loading} onClick={onClose} variant="outlined">
          {cancelButtonLabel}
        </Button>
        <ConfirmButton
          transitionState={loading ? "loading" : "default"}
          color="primary"
          disabled={loading}
          variant="contained"
          onClick={onConfirm}
        >
          {confirmButtonLabel}
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
}

export default CancelBatchDialog;
